import $ from "cash-dom";
import zoom from "./function_zoom";

export default (function () {
    $(document).ready(function () {
        var selector = ".zoom-wrapper";

        if ($(selector).length) {
            if (log) console.log("%cfunction_zoom-image.js initialized", "color: green;");
            var $button = $(selector).parents(".layout").find("[data-zoom]");

            $(selector).each(function () {
                var $target = $(this);
                var focus = $target.data("focus");
                var scale = $target.data("scale");

                zoom($target, focus, scale);
            });

            $button.on("click", function () {
                var $instance = $(this).parents(".layout").find(selector);
                $instance.toggleClass("on");
                $instance.removeClass("delay-lg");
                $button.find("svg").toggleClass("on");
            });
        }
    });
})();
